import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/classes/message';
import { MessageService } from 'src/app/services/message.service';
import { LocationService } from 'src/app/services/location.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditComponent } from '../shifts/edit/edit.component';
import { Shift } from 'src/app/classes/shift';
import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';
import { Router } from '@angular/router';
import { ShiftService } from 'src/app/services/shift.service';
import { Platform } from '@ionic/angular';
import { Title } from '@angular/platform-browser';
import { User } from 'src/app/classes/user';
import * as fa from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent implements OnInit, AfterViewInit {
  @ViewChild('message') message!: ElementRef;
  @ViewChild('messagesBox') messagesBox!: ElementRef;

  messages: Message[] = []
  subscription!: Subscription
  loading = true
  resumeSub!: Subscription
  intervalId!: any
  animatedDots = ''
  isTyping = false
  aiUser!: User
  chatPaused = false
  firstMessageSent = false
  placeholderText = $localize`Write a message...`
  isMobile = /android|iphone|ipad|ipod|windows phone/i.test(navigator.userAgent)
  platform = Capacitor.getPlatform()
  fa = fa

  constructor(
    private cd: ChangeDetectorRef,
    private messageService: MessageService,
    private modalService: NgbModal,
    private shiftService: ShiftService,
    private router: Router,
    private platformApp: Platform,
    private titleService: Title
  ) { }

  async ngOnInit() {
    this.messageService.init()
    
    window.addEventListener('keyboardDidShow', () => {
      this.cd.detectChanges()
      this.messagesBox.nativeElement.scrollTop = this.messagesBox.nativeElement.scrollHeight
    })

    this.titleService.setTitle($localize`Chat`)

    this.messageService.list().subscribe(data => {
      this.messages = data;
      this.cd.detectChanges();

      this.messageService.reset(false)
      this.loading = false

      this.aiUser = this.messages[0].from_user
    })

    this.subscription = this.messageService.listen().subscribe(data => {
      this.messages.push(data);
      this.cd.detectChanges();

      if (data.to_contact_id) {
        this.messageService.delivered(data.id).subscribe(() => { })
      }
    })

    if (Capacitor.getPlatform() != 'web') {
      await Badge.set({ count: 0 });
    }

    this.messageService.reset(false)

    this.resumeSub = this.platformApp.resume.subscribe(async () => {
      if (this.messages.length) {
        this.messageService.connect()


        this.messageService.update(this.messages[this.messages.length - 1].id).subscribe(data => {
          this.messages = this.messages.concat(data);
          this.cd.detectChanges();
        })
      }
    })

    this.intervalId = setInterval(() => {
      this.animatedDots = this.animatedDots.length < 3 ? this.animatedDots + '.' : '';
    }, 250);
  }

  ngAfterViewInit(): void {
    if(Capacitor.getPlatform() == "web") {
      this.message.nativeElement.focus()
    }
  }

  ngOnDestroy(): void {
    this.messageService.reset(true)
    this.subscription.unsubscribe()

    if (this.resumeSub) {
      this.resumeSub.unsubscribe()
    }

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  editShift(shift: Shift) {
    const modalRef = this.modalService.open(EditComponent, { centered: true, size: 'xl', fullscreen: 'lg', scrollable: true })

    // Set the shift id on the modal instance
    modalRef.componentInstance.shift = shift

    // When the modal is closed, reload the shifts
    modalRef.result.then(() => {

    })
  }

  stripHTML(html: string) {
    // Replace <br> tags with new lines
    const withNewLines = html.replace(/<br\s*\/?>/gi, '\n');
    // Remove all other HTML tags
    const strippedText = withNewLines.replace(/<\/?[^>]+(>|$)/g, '');
    return strippedText.trim();
  }

  orderAgain(shiftId: number) {
    this.shiftService.shift(shiftId).subscribe(shift => {
      console.log(shift)
      const order: any = {
        assignment_id: shift.assignment_id,
        employee_id: null,
        customer: {
          id: shift.customer.id,
          street_address: shift.customer.street_address,
          office: shift.customer.office,
          city: shift.customer.city,
          area_id: shift.customer.area_id
        },
        notes: shift.notes,
        products: shift.products.map((product: any) => ({
          product_id: product.product_id,
          number: product.number,
          notes: product.notes
        }))
      }

      if (new Date(shift.start) > new Date()) {
        order.date = shift.start.split('T')[0]
      }

      localStorage.setItem('order', JSON.stringify(order))

      this.router.navigate(['/schedule'])
    })
  }

  links(message: string): string {
    const rexp = /((http|https):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;

    return message.replace(rexp, '<a href="$1" target="_system">$1</a>')
  }

  send() {
    const message = this.stripHTML(this.message.nativeElement.innerHTML)

    if (!message || message.trim() === '') {
      return
    }

    this.isTyping = true
    this.animatedDots = ''

    this.message.nativeElement.innerHTML = ''

    this.messageService.message(message).subscribe({
      next: data => {
        this.firstMessageSent = true;
        this.isTyping = false;
        this.chatPaused = data.chat_paused
      },
      error: () => {
        this.firstMessageSent = true;
        this.isTyping = false;
        this.chatPaused = false
      }
    })
  }

  handleEnterKey(event: Event): void {
    // On desktop we want enter to send!
    if (this.platform === 'web' && !this.isMobile) {
      this.send();
      event.preventDefault();
    }
  }
}
